export default __webpack_public_path__ + "static/outward-block-981a90d6ca9c71f3390343b40b0c0b49.woff";